import Head from "next/head";
import { CookiePreferencesButton } from "@/app/components/CookieConsent/CookiePreferencesButton";
import {
	COOKIE_CONSENT_COOKIE_NAME,
	COOKIE_POLICY_PATH,
} from "@/app/config/cookie-consent";
import { BRAND_NAMES } from "@/app/utils/utils";
import styles from "@/styles/Cookies.module.scss";

const PRIVACY_PORTAL_URL = "https://privacidadecomercio.aguiabranca.com.br";

export default function CookiesPage() {
	return (
		<main className={styles.main}>
			<Head>
				<title>
					Política de Cookies | {BRAND_NAMES.DEFAULT} Toyota
				</title>
				<meta
					name="description"
					content={`Saiba quais cookies a ${BRAND_NAMES.DEFAULT} Toyota utiliza, como gravamos o consentimento (${COOKIE_CONSENT_COOKIE_NAME}) e como alterar suas preferências conforme a LGPD.`}
				/>
				<link
					rel="canonical"
					href={`https://${BRAND_NAMES.URL}.com.br${COOKIE_POLICY_PATH}`}
				/>
			</Head>

			<div className={styles.container}>
				<h1>Política de Cookies</h1>
				<div className={styles.actions}>
					<CookiePreferencesButton className={styles.preferencesBtn} />
				</div>
				<p>
					Este site ({BRAND_NAMES.URL}.com.br) usa cookies para
					funcionar, lembrar suas escolhas e — somente com o seu
					consentimento — medir audiência e exibir conteúdos
					relevantes, em conformidade com a Lei Geral de Proteção de
					Dados (LGPD).
				</p>
				<p>
					No primeiro acesso, o banner de consentimento permite{" "}
					<strong>aceitar</strong>, <strong>rejeitar</strong> ou{" "}
					<strong>personalizar</strong> as categorias. Você pode
					alterar essa escolha a qualquer momento pelo botão acima
					ou pelo rodapé do site.
				</p>

				<h2>Cookie de consentimento</h2>
				<p>
					A escolha é gravada no cookie{" "}
					<strong>{COOKIE_CONSENT_COOKIE_NAME}</strong>, classificado
					como <strong>estritamente necessário</strong>. Sem ele, o
					site não consegue lembrar se você aceitou, recusou ou
					personalizou as categorias, e o banner voltaria a aparecer
					a cada visita.
				</p>

				<div className={styles.tableWrap}>
					<table>
						<thead>
							<tr>
								<th>Cookie</th>
								<th>Categoria</th>
								<th>Duração</th>
								<th>Finalidade</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>
									<code>{COOKIE_CONSENT_COOKIE_NAME}</code>
								</td>
								<td>Necessários</td>
								<td>60 dias</td>
								<td>
									Armazena as preferências de consentimento
									definidas no banner (aceitar, rejeitar ou
									personalizar categorias).
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<h2>Categorias de cookies</h2>
				<div className={styles.tableWrap}>
					<table>
						<thead>
							<tr>
								<th>Categoria</th>
								<th>Obrigatória?</th>
								<th>O que faz</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Necessários</td>
								<td>Sim</td>
								<td>
									Essenciais para o funcionamento do site,
									incluindo gravar o próprio consentimento.
									Não podem ser desligados.
								</td>
							</tr>
							<tr>
								<td>Performance</td>
								<td>Não</td>
								<td>
									Ajustam o site ao visitante (por exemplo,
									localização ou idioma preferido).
								</td>
							</tr>
							<tr>
								<td>Funcional</td>
								<td>Não</td>
								<td>
									Memorizam escolhas e habilitam recursos
									aprimorados. Cookies de serviços como
									Cloudflare entram nesta categoria quando
									ativos.
								</td>
							</tr>
							<tr>
								<td>Marketing</td>
								<td>Não</td>
								<td>
									Acompanham a navegação para oferecer
									anúncios e conteúdos mais relevantes.
								</td>
							</tr>
							<tr>
								<td>Estatísticas</td>
								<td>Não</td>
								<td>
									Traduzem interações em relatórios de
									comportamento, de forma agregada.
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<p>
					Cookies de categorias recusadas são apagados automaticamente
					pelo gerenciador de consentimento. Tags de analytics e
					publicidade só disparam depois do aceite correspondente.
				</p>

				<h2>Como alterar ou recusar</h2>
				<ol>
					<li>
						Use o botão{" "}
						<strong>Mostrar preferências de cookie</strong> nesta
						página ou no rodapé.
					</li>
					<li>
						No painel, aceite tudo, recuse o que não for necessário
						ou ligue apenas as categorias que quiser.
					</li>
					<li>
						Você também pode limpar os cookies do navegador; nesse
						caso o banner volta a ser exibido na próxima visita.
					</li>
				</ol>

				<h2>Privacidade</h2>
				<p>
					Para exercer direitos previstos na LGPD (acesso, correção,
					eliminação e outros) e consultar a política completa de
					privacidade do Grupo Águia Branca, acesse o{" "}
					<a
						href={PRIVACY_PORTAL_URL}
						target="_blank"
						rel="noopener noreferrer"
					>
						Portal de Privacidade
					</a>
					.
				</p>
			</div>
		</main>
	);
}
